<p (click)="infoQrDismiss()">
  Scan your QR Code above to enter and exit. Your FastPass # and points are attached to the QR Code. To be completely touchless, add your credit card to your mobile app.
</p>